import ExportToExcel from "./ExportToExcel";

export default ExportToExcel;